import React, {FC} from 'react';

import {cn} from '@bem-react/classname';

import AnswerStat from '../AnswerStat';

import {countPercent} from './AnswerStats.utils';
import {AnswersStatsProps} from './AnswersStats.types';

const cnAnswersStats = cn('AnswersStats');

const AnswersStats: FC<AnswersStatsProps> = ({totalCount, stats}) => {
    return (
        <div className={cnAnswersStats()}>
            {Object.entries(stats).map(([answer, count], index) => (
                <AnswerStat key={index} label={answer} percent={countPercent(count, totalCount)} />
            ))}
        </div>
    );
};
export default AnswersStats;
